import React from 'react';

export default function DoorOpenOutlined({ style }: { style?: React.CSSProperties; }) {
	return (
		<span role="img" aria-label="ouverture" className="anticon" style={style}>
			<svg
				viewBox="0 0 24 24"
				focusable="false"
				width="1em"
				height="1em"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M3 20h18" />
				<path d="M5 20V4h9v2" />
				<path d="M14 20v-6" />
				<path d="M14 9 19 6v14" />
			</svg>
		</span>
	);
}
